import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'ng2-toastr';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';

import { HomeModule }         from './home/home.module';
import { LoginRoutingModule }   from './login-routing.module';
import { LoginComponent }       from './account/login.component';
import { RegisterComponent }       from './account/register.component';
import { ForgotPasswordComponent }       from './account/forgotpassword.component';

import { ApiService } from './shared';
import { AuthService} from './auth.service';
import { AdminModule }         from './admin/admin.module';
import { DialogService }        from './dialog.service';
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
import { CategoriesModule } from './Categories/Categories.module';
import { CustomerCustomerDemoModule } from './CustomerCustomerDemo/CustomerCustomerDemo.module';
import { CustomerDemographicsModule } from './CustomerDemographics/CustomerDemographics.module';
import { CustomersModule } from './Customers/Customers.module';
import { EmployeesModule } from './Employees/Employees.module';
import { EmployeeTerritoriesModule } from './EmployeeTerritories/EmployeeTerritories.module';
import { OrderDetailsModule } from './OrderDetails/OrderDetails.module';
import { OrdersModule } from './Orders/Orders.module';
import { ProductsModule } from './Products/Products.module';
import { RegionModule } from './Region/Region.module';
import { ShippersModule } from './Shippers/Shippers.module';
import { SuppliersModule } from './Suppliers/Suppliers.module';
import { TerritoriesModule } from './Territories/Territories.module';
import { AlphabeticallistofproductsModule } from './Alphabeticallistofproducts/Alphabeticallistofproducts.module';
import { CategorySalesfor1997Module } from './CategorySalesfor1997/CategorySalesfor1997.module';
import { CurrentProductListModule } from './CurrentProductList/CurrentProductList.module';
import { CustomerandSuppliersbyCityModule } from './CustomerandSuppliersbyCity/CustomerandSuppliersbyCity.module';
import { InvoicesModule } from './Invoices/Invoices.module';
import { OrderDetailsExtendedModule } from './OrderDetailsExtended/OrderDetailsExtended.module';
import { OrderSubtotalsModule } from './OrderSubtotals/OrderSubtotals.module';
import { OrdersQryModule } from './OrdersQry/OrdersQry.module';
import { ProductSalesfor1997Module } from './ProductSalesfor1997/ProductSalesfor1997.module';
import { ProductsAboveAveragePriceModule } from './ProductsAboveAveragePrice/ProductsAboveAveragePrice.module';
import { ProductsbyCategoryModule } from './ProductsbyCategory/ProductsbyCategory.module';
import { QuarterlyOrdersModule } from './QuarterlyOrders/QuarterlyOrders.module';
import { SalesbyCategoryModule } from './SalesbyCategory/SalesbyCategory.module';
import { SalesTotalsbyAmountModule } from './SalesTotalsbyAmount/SalesTotalsbyAmount.module';
import { SummaryofSalesbyQuarterModule } from './SummaryofSalesbyQuarter/SummaryofSalesbyQuarter.module';
import { SummaryofSalesbyYearModule } from './SummaryofSalesbyYear/SummaryofSalesbyYear.module';


@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ToastModule,
	HomeModule,
    AdminModule,
    AppRoutingModule,
    LoginRoutingModule,
		CategoriesModule,
		CustomerCustomerDemoModule,
		CustomerDemographicsModule,
		CustomersModule,
		EmployeesModule,
		EmployeeTerritoriesModule,
		OrderDetailsModule,
		OrdersModule,
		ProductsModule,
		RegionModule,
		ShippersModule,
		SuppliersModule,
		TerritoriesModule,
		AlphabeticallistofproductsModule,
		CategorySalesfor1997Module,
		CurrentProductListModule,
		CustomerandSuppliersbyCityModule,
		InvoicesModule,
		OrderDetailsExtendedModule,
		OrderSubtotalsModule,
		OrdersQryModule,
		ProductSalesfor1997Module,
		ProductsAboveAveragePriceModule,
		ProductsbyCategoryModule,
		QuarterlyOrdersModule,
		SalesbyCategoryModule,
		SalesTotalsbyAmountModule,
		SummaryofSalesbyQuarterModule,
		SummaryofSalesbyYearModule,

  ],
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent
  ],
  providers: [
    ApiService,
    AuthService,
    DialogService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts